import React, { useState, useEffect } from "react";
import {
  AppBar,
  Box,
  Button,
  IconButton,
  Tab,
  Tabs,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Fade from "@mui/material/Fade";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import InputAdornment from "@mui/material/InputAdornment";
import Input from "@mui/material/Input";
import MenuIcon from '@mui/icons-material/Menu';
import { useSelector } from "react-redux";


export default function AllMenuHeader() {
  const [navColor, setnavColor] = useState("transparent");
  const DeliveryAddress = useSelector(state => state.deliveryAddress);
  console.log("DeliveryAddress", DeliveryAddress);
  const listenScrollEvent = () => {
    window.scrollY > 10 ? setnavColor("#F9FFFF") : setnavColor("transparent");
    // window.scrollY > 10 ? setnavSize("5rem") : setnavSize("5rem");
  };
  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent);
    return () => {
      window.removeEventListener("scroll", listenScrollEvent);
    };
  }, []);

  return (
    <>
      <Box
        component="container"
        sx={{
          margin: "20px",
          padding: "0px",
          display: "flex",
          flexDirection: "row",
          justifyContent:'space-between',
          alignItems:'center',
          backgroundColor: navColor,
        }}
      >
        <Box
          sx={{
            width: {
              xl: "199.91px",
              lg: "150px",
              md: "150px",
              sm: "150px",
              xs: "100px",
            },
            height: { lg: "32px", md: "30px", sm: "28px", xs: "30px" },
          }}
        >
          <img src="./images/eatcoast.svg" alt="" width="100%" />
        </Box>


        <Box
          sx={{
            display: {lg:"flex",md:'flex',sm:'none',xs:'none'},
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Box
              sx={{
                width: {lg: "40px", md: "40px", sm: "25px", xs: "20px"},
                height: {lg: "40px", md: "40px", sm: "25px", xs: "20px"},
                paddingLeft: {
                  xl: "130.09px",
                  lg: "130.09px",
                  md: "30px",
                  sm: "50px",
                  xs: "30px",
                },
                paddingRight: "16px",
                // paddingTop: "8px"
              }}
            >
              <img
                src="./images/Frame 720.svg"
                alt=""
                width="100%"
                // height="auto"
              />
            </Box>

            <Box
              sx={{
                borderBottom: "2px solid",
                color: "#F6F6F6",
                width: {lg: "149.57px", md: "149.57px", sm: "90px", xs: "100px"},
              }}
            >
              <Typography
                sx={{
                  fontSize: {lg: "16px", md: "16px", sm: "12px", xs: "12px"},
                  fontWeight: "400",
                  color: "#000000",
                  paddingTop: "4px",
                }}
              >
                {/* {DeliveryAddress} */}
              </Typography>
            </Box>
            <Box sx={{ 
              paddingLeft: "2px", paddingTop: {lg: "8px", md: "8px", sm: "6px", xs: "4px"},
              width: {lg: "24px", md: "24px", sm: "20px", xs: "18px"}
               }}>
              <img src="./images/gps.svg" alt="" width="100%" height="auto" />
            </Box>

            <Box sx={{ paddingLeft: "16.43px" }}>
              <Input
                // fullWidth
                // sx={{width: {lg: "100%", md: "45%", sm: "200px"}}}
                disableUnderline="true"
                startAdornment={
                  <InputAdornment position="start">
                    <Box sx={{
                        width: {lg: "17.75px", md: "17.75px", sm: "14px", xs: "12px"},
                        height: "20.5px",
                      }}>
                    <img
                      src="./images/search-normal.svg"
                      width= "100%"
                      
                    />
                    </Box>
                  </InputAdornment>
                }
                sx={{
                  borderColor: "#E1E1E6",
                  border: "1px solid",
                  width: {
                    xl: "390px",
                    lg: "390px",
                    md: "245px",
                    sm: "200px",
                    xs: "100px",
                  },
                  height: {
                    lg: "40px",
                    md: "36px",
                    sm: "30px",
                    xs: "30px",
                  },
                  borderRadius: "4px",
                  padding: "15px, 24px, 15px, 24px",
                  gap: { lg: "16px", md: "16px", sm: "0px", xs: "0px" },
                  backgroundColor: "#F6F6F6",
                  color: "#9EA3AE",
                  paddingLeft: "27.12px",
                }}
              ></Input>
            </Box>
          </Box>

          <Box sx={{ display: "flex", flexDirection: "row" }}>
            <Box
              sx={{
                paddingLeft: {
                  xl: "136px",
                  lg: "112px",
                  md: "40px",
                  sm: "20px",
                  xs: "20px",
                },
              }}
            >
              <Button
              
                sx={{
                  // marginLeft: "auto",
                  borderRadius: "6px",
                  fontSize: { lg: "16px", md: "12px", sm: "12px", xs: "12px" },
                  fontWeight: "600",
                  textTransform: "capitalize",
                  height: {lg: "40px", md: "40px", sm: "30px", xs: "22px"},
                  width: {lg: "81px", md: "81px", sm: "50px", xs: "40px"},
                }}

                variant="outlined"
                
              >
                Login
              </Button>
            </Box>

            <Box>
              <Button
              size="small"
                sx={{
                  marginLeft: {
                    xl: "8px",
                    lg: "8px",
                    md: "8px",
                    sm: "8px",
                    xs: "4px",
                  },
                  borderRadius: "6px",
                  fontSize: { lg: "16px", md: "12px", sm: "12px", xs: "12px" },
                  fontWeight: "600",
                  height: {lg: "40px", md: "40px", sm: "30px", xs: "22px"},
                  textTransform: "capitalize",
                  // width: "97px",
                }}
                variant="contained"

              >
                Sign Up
              </Button>
            </Box>
          </Box>
        </Box>

        <Box sx={{
          display:{lg:'none',md:'none',sm:'flex',xs:'flex'},
          flexDirection:'row',
          justifyContent:'end'
        }}>
                <Box>
                  <IconButton aria-label="delete">
                    <MenuIcon/>
                  </IconButton>
                </Box>
        </Box>

      </Box>
    </>
  );
}
